<template>
  <div class="border-t border-t-gray-200 dark:border-t-gray-800 px-4 py-3 sm:rounded-b-md sm:px-6">
    <slot />
  </div>
</template>

<script setup lang="ts"></script>
